import util from './util';
import { BRANCH_LOWER_TEXT } from "lofty_region/const.js";
import { formatDateISO, formatDate } from '@/common/format';
function formatTimeStamp(date, year) {
    let [dateTime, timeStamp] = date.split(',');
    let t12s = [];
    if (dateTime && timeStamp) {
        let result = timeStamp.replace(/([^\-\s])+/g, function(match) {
            let timesPm = match.match(/([\s\S]+)pm/);
            let timesAm = match.match(/([\s\S]+)am/);
            let formatTime = '';
            if (timesAm && timesAm[1]) {
                let [hour, minute] = timesAm[1].split(':');
                t12s.push(hour + 'AM');
                if (hour == 12) {
                    hour = 0;
                }
                let amTime = Number(hour) + ':' + minute;
                formatTime = [dateTime, year, amTime].join(' ');
            }

            if (timesPm && timesPm[1]) {
                let [hour, minute] = timesPm[1].split(':');
                t12s.push(hour + 'PM');
                if (hour == 12) {
                    hour = 0;
                }
                let pmTime = 12 + Number(hour) + ':' + minute;
                formatTime = [dateTime, year, pmTime].join(' ');
            }

            return formatTime;
        });

        result = result.split('-');

        return [{
            time: result[0],
            t12: t12s[0]
        }, {
            time: result[1],
            t12: t12s[1]
        }];
    } else {
        return [];
    }
}

function convert24to12(time) {
    let date = new Date(time);

    let hours = date.getHours();
    let minutes = date.getMinutes();

    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    // fill zero
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
}

function formatDescription(info, external) {
    let houseType = '';
    if (info.openHouseFlag == 1) {
        houseType = 'open house';
    } else if (external.isTour3d) {
        houseType = 'virtual tour';
    }

    // prettier-ignore
    return `Join us for an exciting ${houseType} event at ${external.streetCityName}.`;
}

function getEvent(info, external) {
    const streetCityName =
        info.address || [info.streetAddress, info.cityAddress].join();

    const price = info.soldPrice || info.price || 0;
    const url = external.url;

    const priceCurrency = external.currencyAbbr || 'USD';
    const isSold = Boolean(info.soldDateStr);
    const availability = isSold
        ? 'http://schema.org/SoldOut'
        : 'http://schema.org/InStock';
    const image =
        info.previewPicture ||
        (info.listingPictures && info.listingPictures.split('|')[0]);

    let createYear = new Date().getFullYear();
    if (info.createDate) {
        createYear = new Date(info.createDate).getFullYear();
    }
    let agentCreator = external.agentCreator || {};

    let startTime = '';
    let endTime = '';

    let eventName = '';
    let eventAttendanceMode = 'https://schema.org/OfflineEventAttendanceMode';
    let locationInfo = {
        '@type': 'Place',
        '@context': 'http://schema.org',
        name: streetCityName,
        address: {
            '@type': 'PostalAddress',
            '@context': 'http://schema.org',
            streetAddress: streetCityName,
            postalCode: info.zipCode,
            addressLocality: info.city,
            addressRegion: info.state
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: info.latitude,
            longitude: info.longitude
        }
    };

    if (info.openHouseFlag == 1) {

        if (info.openHouseSchedule) {
            let formatTime = formatTimeStamp(
                info.openHouseSchedule,
                createYear
            );
            startTime = formatTime[0];
            endTime = formatTime[1];
        } else if (info.openHouseSchedules) {
            let schedule = '';
            if (util.isArray(info.openHouseSchedules)) {
                schedule = info.openHouseSchedules[0];
            } else {
                schedule = info.openHouseSchedules.split('|')[0];
            }
            let formatTime = formatTimeStamp(schedule, createYear);
            startTime = formatTime[0];
            endTime = formatTime[1];
        }

        if (startTime && endTime) {
            eventName = 'Open House - ' + startTime.t12 + '-' + endTime.t12;
            startTime = startTime.time;
            endTime = endTime.time;
            if (new Date(startTime).toString() == 'Invalid Date') {
                console.log('time invalid');
                console.log(startTime, endTime, info);
                return null;
            }
        } else {
            if (info.openHouseSchedulesStart) {
                startTime = info.openHouseSchedulesStart.replace(/-/g, '/');
            }

            if (info.openHouseSchedulesEnd) {
                endTime = info.openHouseSchedulesEnd.replace(/-/g, '/');
            }

            eventName = 'Open House - ' + convert24to12(startTime) + '-' + convert24to12(endTime);
        }
    } else if (external.isTour3d) {
        eventAttendanceMode = 'https://schema.org/OnlineEventAttendanceMode';
        eventName = '3D Tour Available ' + streetCityName;
        locationInfo = {
            '@type': 'VirtualLocation',
            url
        };
        startTime = new Date().toString();
        endTime = new Date().toString();
    }

    external = Object.assign(external, {
        streetCityName: streetCityName,
        price: price
    });

    var res = {
        '@type': 'Event',
        '@context': 'https://schema.org',
        name: eventName,
        startDate: new Date(startTime),
        endDate: new Date(endTime),
        url,
        description: formatDescription(info, external),
        image,
        eventAttendanceMode: eventAttendanceMode,
        eventStatus: 'https://schema.org/EventScheduled',
        offers: {
            '@type': 'Offer',
            price,
            priceCurrency,
            url,
            availability,
            validFrom: startTime
        },
        organizer: {
            '@type': 'Organization',
            name: info.agentOrganizationName,
            url
        },
        location: locationInfo,
        performer: {
            '@type': 'Person',
            name: info.agentName || agentCreator.fullName
        }
    };

    if (
        Number.isNaN(res.startDate.getTime()) ||
        Number.isNaN(res.endDate.getTime())
    ) {
        return null;
    } else {
        return res;
    }
}

// function getSingleFamilyResidence(info, url, country) {
//     const streetCityName = [info.streetAddress, info.cityAddress].join();
//     return {
//         '@type': 'SingleFamilyResidence',
//         name: streetCityName,
//         url,
//         address: {
//             '@type': 'PostalAddress',
//             streetAddress: info.streetAddress,
//             addressLocality: info.city,
//             addressRegion: info.state,
//             postalCode: info.zipCode,
//             addressCountry: country
//         },
//         geo: {
//             '@type': 'GeoCoordinates',
//             latitude: info.latitude,
//             longitude: info.longitude
//         },
//         numberOfRooms: info.bedrooms
//     };
// }

/**
 *
 * @param {listingDetail} info
 * @param {option:{country}} param1
 * @returns schema.org info used by search engine
 */
function getListingDetailSchemaInfo(info, external) {
    let { location } = external;
    const url = location.origin + location.pathname;
    external.url = url;

    let chime3DTour = info.chime3DTourFlag == 'Yes' || info.tour3D;
    let schemaInfo = null;
    let eventInfo = null;
    if (chime3DTour || info.openHouseFlag == 1) {
        external.isTour3d = chime3DTour;
        eventInfo = getEvent(info, external);
    }

    if (eventInfo) {
        schemaInfo = Object.assign(
            {
                ...eventInfo
                // ...getSingleFamilyResidence(info, url, country)
            },
            // { '@type': ['Event', 'SingleFamilyResidence'] }
            { '@type': 'Event' }
        );
    } else {
        // schemaInfo = Object.assign(
        //     {
        //         ...getSingleFamilyResidence(info, url, country)
        //     },
        //     { '@type': 'SingleFamilyResidence' }
        // );
    }

    return schemaInfo ? [schemaInfo] : null;
}

function getHouseSchemaInfo(info, external) {
    let { url, location } = external;
    url = `${location.origin}${url}`;
    external.url = url;

    let chime3DTour = info.chime3DTourFlag == 'Yes' || info.tour3D;
    let schemaInfo = null;
    let eventInfo = null;
    if (chime3DTour || info.openHouseFlag == 1) {
        external.isTour3d = chime3DTour;
        eventInfo = getEvent(info, external);
    }

    if (eventInfo) {
        schemaInfo = [
            // getSingleFamilyResidence(info, url, country),
            eventInfo
        ];
    } else {
        // schemaInfo = [getSingleFamilyResidence(info, url, country)];
    }

    return schemaInfo;
}

function getVideoSchemeInfo({ embedUrl, thumbnailUrl, duration }) {
    var res = {
        embedUrl,
        thumbnailUrl:
            thumbnailUrl ||
            'https://static.chimeroi.com/servicetool-temp/202397/1/lofty-logo/Lofty_Logo.png',
        name: `${BRANCH_LOWER_TEXT} video`,
        description: `${BRANCH_LOWER_TEXT} video`,
        uploadDate: '2023-03-29 13:08:35',
        expires: '2023-04-03 23:59:59',
        '@type': 'VideoObject'
    };
    if (duration) {
        res.duration = `PT${duration}S`;
    }
    return res;
}

/**
 * Generate Place schema for neighborhood/featured area pages
 * Follows Schema.org Place specification: https://schema.org/Place
 * @param {Object} areaInfo - Area/neighborhood information
 * @param {Object} external - External options { location, country }
 * @returns {Object|null} Place schema object or null
 */
function getPlaceSchemaInfo(areaInfo, external) {
    if (!areaInfo || !areaInfo.name) {
        return null;
    }

    let { location = {}, country = '' } = external;
    const url = location.origin + location.pathname;

    const placeName = areaInfo.name;
    const addressLocality = areaInfo.city || '';
    const addressRegion = areaInfo.state || '';
    const postalCode = areaInfo.zipCode || areaInfo.postalCode || '';
    const streetAddress = areaInfo.streetAddress || areaInfo.address || '';

    const description = areaInfo.description ||
                       areaInfo.introPageExtraDescription ||
                       areaInfo.desc || '';

    const image = areaInfo.image ||
                 areaInfo.introPageExtraBackground ||
                 areaInfo.backgroundImage ||
                 areaInfo.coverImage || '';

    const address = {
        '@type': 'PostalAddress',
        streetAddress: streetAddress || 'N/A',
        addressLocality: addressLocality || '',
        addressRegion: addressRegion || '',
        postalCode: postalCode || '00000',
        addressCountry: country || ''
    };

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Place',
        name: placeName,
        description: description || '',
        url: url,
        image: image || '',
        address: address,
        geo: {
            '@type': 'GeoCoordinates',
            latitude: areaInfo.nbrMapData?.lat || 0,
            longitude: areaInfo.nbrMapData?.lng || 0
        }
    };

    return schema;
}

function getMapSchemaInfo(mapInfo, external) {
    if (!mapInfo || !mapInfo.name) {
        return null;
    }

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'City',
        name: mapInfo.name
    };

    // Add region if provided
    if (mapInfo.region) {
        schema.region = mapInfo.region;
    }

    // Process schools data if available
    if (mapInfo.schools && Array.isArray(mapInfo.schools) && mapInfo.schools.length > 0) {
        const schoolGroups = {
            middleSchools: [],
            highSchools: [],
            elementarySchools: []
        };

        // Group schools by level
        mapInfo.schools.forEach(school => {
            const level = school.level?.toLowerCase();
            const schoolData = {
                name: school.name || '',
                category: school.admission || 'Unknown',
                grades: formatGradeRange(school.gradeLow, school.gradeHigh),
                studentTeacherRatio: school.studentTeacherRatio || 'N/A',
                library: school.library ? 'Yes' : 'No'
            };

            if (level?.includes('middle')) {
                schoolGroups.middleSchools.push(schoolData);
            } else if (level?.includes('high')) {
                schoolGroups.highSchools.push(schoolData);
            } else if (level?.includes('elementary')) {
                schoolGroups.elementarySchools.push(schoolData);
            }
        });

        // Build educational environment structure
        const grades = {};
        let hasSchools = false;

        if (schoolGroups.middleSchools.length > 0) {
            grades.middleSchools = {
                '@type': 'EducationalOccupancy',
                name: 'Middle Schools',
                schools: schoolGroups.middleSchools
            };
            hasSchools = true;
        }

        if (schoolGroups.highSchools.length > 0) {
            grades.highSchools = {
                '@type': 'EducationalOccupancy',
                name: 'High Schools',
                schools: schoolGroups.highSchools
            };
            hasSchools = true;
        }

        if (schoolGroups.elementarySchools.length > 0) {
            grades.elementarySchools = {
                '@type': 'EducationalOccupancy',
                name: 'Elementary Schools',
                schools: schoolGroups.elementarySchools
            };
            hasSchools = true;
        }

        if (hasSchools) {
            schema.educationalEnvironment = {
                '@type': 'EducationalOccupationalOccupancy',
                name: `${mapInfo.name} Schools`,
                grades: grades
            };
        }
    }

    return schema;
}

/**
 * Format grade range from low and high grade values
 * @param {string} gradeLow - Lowest grade (e.g., "KG", "1", "6")
 * @param {string} gradeHigh - Highest grade (e.g., "5", "8", "12")
 * @returns {string} Formatted grade range (e.g., "KG-5", "6-8", "9-12")
 */
function formatGradeRange(gradeLow, gradeHigh) {
    if (!gradeLow && !gradeHigh) {
        return 'N/A';
    }

    const low = gradeLow || '';
    const high = gradeHigh || '';

    if (low && high) {
        return `${low}-${high}`;
    } else if (low) {
        return low;
    } else if (high) {
        return high;
    }

    return 'N/A';
}

/**
 * Extract plain text from HTML string
 * Uses DOMParser (browser) or regex fallback (SSR) to handle HTML tags and entities
 * Important: Removes script and style tags and their content before extracting text
 * @param {string} htmlString - HTML string to convert
 * @returns {string} Plain text (max 500 characters)
 */
function getPlainTextFromHTML(htmlString) {
    if (!htmlString) {
        return '';
    }

    let text = '';

    // SSR environment: Manual HTML tag removal and entity decoding

    // HTML entity mapping table
    const htmlEntities = {
        '&nbsp;': ' ',
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&apos;': "'",
        '&mdash;': '—',
        '&ndash;': '–',
        '&hellip;': '…',
        '&copy;': '©',
        '&reg;': '®',
        '&trade;': '™',
        '&euro;': '€',
        '&pound;': '£',
        '&yen;': '¥'
    };

    text = htmlString
    // Remove script and style tags with their content FIRST
        .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '')
    // Remove remaining HTML tags
        .replace(/<[^>]*>/g, '')
    // Decode all HTML entities in one pass
        .replace(/&[a-z]+;|&#\d+;|&#x[0-9A-Fa-f]+;/gi, (entity) => {
            // Named entities (e.g., &nbsp;, &copy;)
            if (htmlEntities[entity]) {
                return htmlEntities[entity];
            }
            // Numeric entities - decimal (e.g., &#39;)
            if (entity.startsWith('&#') && !entity.startsWith('&#x')) {
                const dec = entity.match(/\d+/)[0];
                return String.fromCharCode(parseInt(dec, 10));
            }
            // Numeric entities - hexadecimal (e.g., &#x27;)
            if (entity.startsWith('&#x')) {
                const hex = entity.match(/[0-9A-Fa-f]+/)[0];
                return String.fromCharCode(parseInt(hex, 16));
            }
            // Unknown entity, keep as-is
            return entity;
        })
        .replace(/\s+/g, ' ')  // Collapse multiple whitespace to single space
        .trim()                 // Remove leading/trailing whitespace
        .substring(0, 500);     // Limit to 500 characters
    return text
}

/**
 * Generate BlogPosting schema for blog article pages
 * Follows Schema.org BlogPosting specification: https://schema.org/BlogPosting
 * @param {Object} blogInfo - Current blog article information
 * @param {Array} blogPosts - Array of blog posts (not used in new format)
 * @param {Object} external - External options { location, company, logo }
 * @returns {Object|null} BlogPosting schema object or null
 */
function getBlogSchemaInfo(blogInfo, blogPosts, external) {
    if (!blogInfo || !blogInfo.title) {
        return null;
    }

    let { location, company, logo } = external;
    const baseUrl = location.origin;
    const blogUrl = baseUrl + location.pathname;

    const description = blogInfo.description ||
                       (blogInfo.content ? getPlainTextFromHTML(blogInfo.content) : '');

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': blogUrl
        },
        headline: blogInfo.title || '',
        description: description
    };

    if (blogInfo.author) {
        schema.author = {
            '@type': 'Person',
            name: blogInfo.author
        };
    }

    const publisher = {
        '@type': 'Organization',
        name: company?.name || ''
    };

    if (logo) {
        publisher.logo = {
            '@type': 'ImageObject',
            url: logo
        };
    }
    schema.publisher = publisher;

    if (blogInfo.publishTime) {
        schema.datePublished = formatDateISO(blogInfo.publishTime);
    }

    if (blogInfo.dateModified || blogInfo.publishTime) {
        schema.dateModified = formatDateISO(blogInfo.dateModified || blogInfo.publishTime);
    }

    return schema;
}

/**
 * Generate Review schema for testimonial/review pages
 * Follows Schema.org Organization with Review specification
 * @param {Array} testimonials - Array of testimonial/review objects
 * @param {Object} external - External options { location, company }
 * @returns {Object|null} Organization schema object with reviews or null
 */
function getTestimonialSchemaInfo(testimonials, external) {
    if (!testimonials || !Array.isArray(testimonials) || testimonials.length === 0) {
        return null;
    }

    const { location, company } = external;
    const baseUrl = location.origin;
    const companyName = company?.name || '';

    const reviews = testimonials.map((testimonial) => {
        if (!testimonial.reviewerName || !testimonial.reviewContent) {
            return null;
        }

        const author = {
            '@type': 'Person',
            name: testimonial.reviewerName.trim() || ''
        };

        if (testimonial.avatarLink) {
            author.image = testimonial.avatarLink;
        }

        const reviewBody = getPlainTextFromHTML(testimonial.reviewContent);

        if (!reviewBody || !reviewBody.trim()) {
            return null;
        }

        const rawRating = Number(testimonial.reviewRate);
        const ratingValue = (rawRating && rawRating >= 1 && rawRating <= 5)
            ? String(rawRating)
            : '1';

        const review = {
            '@type': 'Review',
            author: author,
            itemReviewed: {
                '@type': 'Organization',
                name: companyName,
                url: baseUrl
            },
            reviewRating: {
                '@type': 'Rating',
                ratingValue: ratingValue
            },
            reviewBody: reviewBody.trim()
        };

        if (testimonial.reviewTime) {
            const formattedDate = formatDate(testimonial.reviewTime);
            if (formattedDate) {
                review.datePublished = formattedDate;
            }
        }

        return review;
    }).filter(item => item !== null);

    if (reviews.length === 0) {
        return null;
    }

    let totalRating = 0;
    let ratingCount = 0;
    testimonials.forEach(t => {
        const rating = Number(t.reviewRate);
        if (rating && rating >= 1 && rating <= 5) {
            totalRating += rating;
            ratingCount++;
        }
    });
    const avgRating = ratingCount > 0 ? (totalRating / ratingCount).toFixed(1) : '0';

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: companyName,
        url: baseUrl,
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: avgRating,
            reviewCount: String(testimonials.length)
        },
        review: reviews
    };

    return schema;
}

function sanitizePathSegment(str) {
    if (!str) {
        return '';
    }
    return str.replace(/\//g, '-').replace(/[^a-zA-Z0-9-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
}

/**
 * Generate BreadcrumbList schema for listing detail pages
 * Follows Schema.org BreadcrumbList specification: https://schema.org/BreadcrumbList
 * @param {Object} info - Listing detail information
 * @param {Object} external - External options { location, page }
 * @returns {Object|null} BreadcrumbList schema object or null
 */
function getBreadcrumbSchemaInfo(info, external) {
    if (!info) {
        return null;
    }

    const { location, page } = external;
    const baseUrl = location.origin;
    const itemListElement = [];
    let position = 1;

    const state = sanitizePathSegment(info.state || '');
    const city = sanitizePathSegment(info.city || '');
    const subdivision = sanitizePathSegment((!/null|undefined/gi.test(info.subDivisionName) && info.subDivisionName) || '');
    const address = info.address || info.streetAddress || '';

    // Home
    itemListElement.push({
        '@type': 'ListItem',
        position: position++,
        name: 'Home',
        item: baseUrl
    });

    // State level - always use base URL (home page) as state-only pages don't exist
    // Neither traditional mode nor FEATURE_AREA_VERSION mode have state-only listing pages
    if (state) {
        itemListElement.push({
            '@type': 'ListItem',
            position: position++,
            name: state,
            item: baseUrl
        });
    }

    if (state && city) {
        let cityUrl;
        if (page && page['FEATURE_AREA_VERSION']) {
            const sanitizedCity = city.toLowerCase().replace(/\s+/g, '-');
            const sanitizedState = state.replace(/\s+/g, '-');
            cityUrl = `${baseUrl}/area/${sanitizedCity}-${sanitizedState}/listings`;
        } else {
            cityUrl = `${baseUrl}/${state}/${city}`;
        }

        itemListElement.push({
            '@type': 'ListItem',
            position: position++,
            name: city,
            item: cityUrl
        });
    }

    if (state && city && subdivision) {
        let sbdvUrl;
        if (page && page['FEATURE_AREA_VERSION']) {
            const sanitizedCity = city.toLowerCase().replace(/\s+/g, '-');
            const sanitizedState = state.replace(/\s+/g, '-');
            const sanitizedSubdivision = subdivision.replace(/\s+/g, '-');
            sbdvUrl = `${baseUrl}/area/${sanitizedCity}-${sanitizedState}/${sanitizedSubdivision}/listings`;
        } else {
            sbdvUrl = `${baseUrl}/${state}/${subdivision},${city}`;
        }

        itemListElement.push({
            '@type': 'ListItem',
            position: position++,
            name: subdivision,
            item: sbdvUrl
        });
    }

    if (address) {
        itemListElement.push({
            '@type': 'ListItem',
            position: position++,
            name: address,
            item: baseUrl + location.pathname
        });
    }

    if (itemListElement.length <= 1) {
        return null;
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement
    };
}

export { getListingDetailSchemaInfo, getHouseSchemaInfo, getVideoSchemeInfo, getPlaceSchemaInfo, getMapSchemaInfo, getBlogSchemaInfo, getTestimonialSchemaInfo, getBreadcrumbSchemaInfo };
